import Sticky from 'sticky-js';

import { Controller } from 'stimulus';

export default class extends Controller {
  initialize() {
    this.ticking = false;
    this.visible = false;
    this.lastY = 0;

    window.addEventListener('scroll', () => {
      const currentY = window.scrollY;

      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.lastY = currentY;
          this.whenScrolling();
          this.ticking = false;
        });

        this.ticking = true;
      }
    });
  }

  whenScrolling() {
    if (this.lastY >= 500 && !this.visible) {
      this.element.classList.add('is-active');
      this.visible = true;
    } else {
      if (this.lastY < 500 && this.visible) {
        this.hideScroller();
      }
    }
  }

  hideScroller() {
    this.element.classList.remove('is-active');
    this.visible = false;
  }

  top() {
    window.scrollTo(0, 0);
    this.hideScroller();
  }
}
